import React from 'react';

import '@app/scss/components/middleText.scss';

interface MiddleTextProps {
	title?: string;
	text?: string | any;
	style?: any;
}

const MiddleText: React.FC<MiddleTextProps> = ({
	title,
	text,
	children,
	style = null,
}) => (
	<article className="middle-text">
		{title && <h4 className="middle-text__title">{title}</h4>}
		{text && <div className="middle-text__text" dangerouslySetInnerHTML={{ __html: text }} style={style} />}
		{children}
	</article>
);

export default MiddleText;
